export const SET_ORDER_SETTINGS_DATA_LOADING = "SET_ORDER_SETTINGS_DATA_LOADING";
export const SET_ORDER_SETTINGS_DATA = "SET_ORDER_SETTINGS_DATA";
export const CLEAR_ORDER_SETTINGS_DATA = "CLEAR_ORDER_SETTINGS_DATA";